import { action, runInAction, makeObservable } from "mobx";
import AutotextosApi from "../api/AutotextosApi";
import { FiltroPesquisaAutotexto } from "../modelo/FiltroPesquisaAutotexto";
import { Autotexto } from "../modelo/Autotexto";
import MensagemStore from "../../store/MensagemStore"
import AutotextoStore from "../stores/AutotextoStore"
import { AutotextoAgrupado } from "../modelo/AutotextoAgrupado";
import { textoSimilar } from '../utils/duplicidadeUtils';

class AutotextosService {
    constructor() {
        makeObservable(this, {
            resetAutotextos: action
        });
    }

    async recuperarTodos(): Promise<Autotexto[]> {
        const autotextos = await AutotextosApi.recuperarTodos();
        return autotextos.sort((e1, e2) => {
            if (e1.nome.toLowerCase() >= e2.nome.toLowerCase()) {
                return 1;
            } else {
                return -1;
            }
        });
    }

    async recuperarAgrupados(): Promise<AutotextoAgrupado[]> {
        const agrupados = await AutotextosApi.recuperarAgrupados();
        return this.adicionarTitulosAutotexto(agrupados);
    }

    async filtrar(filtro: FiltroPesquisaAutotexto): Promise<Autotexto[]> {
        return AutotextosApi.filtrar(filtro);
    }

    pegarTitulosCadastrados = () => {
        const opcoesTitulos = AutotextoStore.optionsAutotextosTitulo;
        return opcoesTitulos.map(opcao => opcao.texto);
    }

    filledField(name: string, value: any) {
        if (!value) {
            MensagemStore.apresentarErro('O campo "'+name + '" é obrigatório!');
            return false;
        }
        return true;
    }

    tituloSimilar(atual: string, novo: string) {
        if (!novo) {
            return false;
        }
        if (atual === novo) {
            return false;
        }
        const cadastrados = this.pegarTitulosCadastrados();

        const similar = textoSimilar(atual, novo, cadastrados);

        if (similar) {
            MensagemStore.apresentarErro('Categoria similar encontrada: "' + similar + '"');
            return true;
        }
        return false;
    }

    async salvarAutotexto(autotexto: Autotexto) {
        if (autotexto.id) {
            await AutotextosApi.atualizar(autotexto).then(() => {
                runInAction(() => {
                    AutotextoStore.autotextoParaEdicao = undefined;
                });
                MensagemStore.apresentarMensagem('Autotexto atualizado');
            });
        } else {
            await AutotextosApi.salvar(autotexto).then(() => {
                MensagemStore.apresentarMensagem('Autotexto salvo');
            });
        }
    }

    excluir(autotexto: Autotexto) {
        return AutotextosApi.excluir(autotexto);
    }

    carregarAutotextos = async () => {
        const autotextos = await this.recuperarTodos();

        runInAction(() => {
            AutotextoStore.autotextos = autotextos;
            AutotextoStore.autotextosFiltrado = autotextos;
        });

    }

    atribuirAutotextoParaEdicao(autotexto: Autotexto) {
        runInAction(() => {
            AutotextoStore.autotextoParaEdicao = autotexto;
        })
    }

    resetAutotextos = () => {
        AutotextoStore.autotextosFiltrado = AutotextoStore.autotextos;
    };

    addTitulosAutotexto(autotextosAgrupados: AutotextoAgrupado[]): AutotextoAgrupado[] {
        return autotextosAgrupados.map((grupo) => {
            if (grupo.descricao === AutotextoAgrupado.DESCRICAO_COM_TITULOS) {
                const camposComTitulos =
                    AutotextoAgrupado.getGruposAutotextoBy(
                        grupo.campos, AutotextoAgrupado.CAMPO_TIULO);
                const novoGrupo = grupo;
                novoGrupo.filhos = camposComTitulos;
                return novoGrupo;
            }
            return grupo;
        });
    }

    adicionarTitulosAutotexto(autotextosAgrupados: AutotextoAgrupado[]): AutotextoAgrupado[] {
        const grupoAutotexto = () => {
            return autotextosAgrupados.filter((grupo) => {
                return grupo.descricao === AutotextoAgrupado.DESCRICAO_COM_TITULOS;
            })[0]?.campos;
        }
        const autotextosComTitulo =
            AutotextoAgrupado.getGruposAutotextoBy(
                grupoAutotexto(), AutotextoAgrupado.CAMPO_TIULO);

        const agrupados = autotextosAgrupados;
        agrupados.forEach((agrupado) => {
            if (agrupado.descricao === AutotextoAgrupado.DESCRICAO_COM_TITULOS) {
                agrupado.filhos = autotextosComTitulo;
            }
        })

        return autotextosAgrupados;
    }
}

export default new AutotextosService();
